import { Form } from '@rocketseat/unform';
import {
  Breadcrumbs,
  Button,
  Table,
  TableCell,
  TableHeader,
  TableRow,
  Text,
  Title,
  WrapperFlex,
} from '@unimed-fesp/components';
import format from 'date-fns/format';
import produce from 'immer';
import React from 'react';

import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { WarningToast } from '../../components/molecules/Toast';
import history from '../../services/history';
import theme from '../../styles/theme';

import { isAdmin } from '../../utils/userRole';

import { CardPersonalInformation, Container } from './styles';

import FadeIn from '../../components/atoms/FadeIn';

import LoadingSpinner from '../../components/molecules/LoadingSpinning';

import { Creators as RequisicaoActions } from '../../store/ducks/requisicao';
import { downloadFile } from '../../utils/base64';
import DetalheSolicitacao from './DetalheSolicitacao';
import FormSolicitacao from './FormSolicitacao';
import { ModalSolicitacoes } from './ModalSolicitacoes';
import { ModalSuccess } from './ModalSuccess';

function SolicitacaoSegundaVia({ match }) {
  const {
    getSegundaViaCartao,
    getAnexoSegundaVia,
    putSegundaViaCartao,
    postSegundaViaCartao,
  } = useSelector((state) => state.requisicao);
  const { usuario } = useSelector((state) => state.auth);

  const { idSolicitacao } = match.params;
  const { state, pathname } = history.location;

  const dispatch = useDispatch();

  const updateSolicitationParams = {
    requisition_id: 0,
    reason_code: 0,
    description: null,
    status_code: null,
    user_id: usuario.idUsuarioLogado,
    beneficiary_id: 0,
    attachment: null,
    name_attachment: null,
    is_need_attachment: false,
  };

  const newSolicitationParams = {
    request_user_id: usuario.idUsuarioLogado,
    document_number: null,
    wallet_number: null,
    beneficiary_requisition_filter: null,
    beneficiary_id: null,
    request_reason_id: null,
    request_type_id: 1,
    request_status_id: 1,
    description: null,
    attachment: null,
    name_attachment: null,
    is_need_attachment: false,
  };

  const [updateSolicitation, setUpdateSolicitation] = useState(
    updateSolicitationParams
  );
  const [deleteAttachment, setDeleteAttachment] = useState(false);
  const [newSolicitation, setNewSolicitation] = useState(newSolicitationParams);
  const [files, setFiles] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [message, setMessage] = useState(null);
  const [openModalSuccess, setOpenModalSuccess] = useState({
    success: false,
    message: '',
  });

  const getActionLabel = () => {
    if (pathname.includes('editar')) {
      return 'Editar Solicitação';
    }
    if (pathname.includes('detalhe')) {
      return 'Detalhes da Solicitação';
    }
    if (pathname.includes('solicitar')) {
      return 'Nova Solicitação';
    }
    return '';
  };
  const actionLabel = getActionLabel();

  useEffect(() => {
    if (pathname.includes('solicitar') && !state) {
      return history.push({
        pathname: `/novo/segunda-via/`,
      });
    }

    if (actionLabel !== 'Nova Solicitação') {
      if (
        !state?.data?.requisitionId ||
        state.data.user.role !== usuario.role ||
        usuario.codigoContratante !== state.data.user.codigoContratante
      ) {
        return history.push({
          pathname: `/novo/segunda-via/`,
        });
      }
      dispatch(
        RequisicaoActions.postSegundaViaBuscarPorIdRequest({
          requisition_id: state?.data?.requisitionId,
          contractor_code: isAdmin(usuario.role)
            ? null
            : usuario.codigoContratante,
        })
      );
    }
  }, []);

  useEffect(() => {
    if (
      actionLabel === 'Editar Solicitação' &&
      (getSegundaViaCartao.response.statusDescription === 'Processado' ||
        getSegundaViaCartao.response.statusDescription === 'Não Processado')
    ) {
      history.push({
        pathname: `/novo/segunda-via/${idSolicitacao}/detalhe`,
        state: state?.data,
      });
    }
  }, [getSegundaViaCartao.response]);

  useEffect(() => {
    if (!getAnexoSegundaVia.loading && getAnexoSegundaVia.success) {
      if (
        getAnexoSegundaVia.response !== '' &&
        getAnexoSegundaVia.response.sucess !== 'ok'
      ) {
        const extension = getSegundaViaCartao?.response?.nameAttachment
          ?.split('.')
          .pop();

        downloadFile(
          getAnexoSegundaVia.response,
          getSegundaViaCartao?.response?.nameAttachment,
          extension
        );
      }
      dispatch(RequisicaoActions.getSegundaViaAnexoSuccess(false, false));
    }
  }, [getAnexoSegundaVia.loading, getAnexoSegundaVia.response]);

  useEffect(() => {
    if (
      typeof postSegundaViaCartao.response === 'number' &&
      postSegundaViaCartao.success
    ) {
      handleModalSuccess('nova');
      dispatch(RequisicaoActions.postSolicitarSegundaViaSuccess(false, {}));
    }
  }, [postSegundaViaCartao.response]);

  useEffect(() => {
    if (
      putSegundaViaCartao.response.success &&
      deleteAttachment &&
      getAnexoSegundaVia.response.sucess === 'ok'
    ) {
      handleModalSuccess('update');
      dispatch(RequisicaoActions.putSegundaViaUpdateSuccess(false, {}));
      dispatch(RequisicaoActions.getSegundaViaAnexoSuccess(false, {}));
    }

    if (putSegundaViaCartao.response.success) {
      handleModalSuccess('update');
      dispatch(RequisicaoActions.putSegundaViaUpdateSuccess(false, {}));
    }
  }, [putSegundaViaCartao.response.success]);

  const handleSubmit = (data) => {
    const reason = {
      'Furto/Roubo com boletim de ocorrência': 15,
      'Furto/Roubo sem boletim de ocorrência': 8,
      'Nova via com cobrança de dados': 12,
      'Problemas na tarja autorizada': 13,
      Perda: 14,
    };
    const statusCode = {
      Pendente: 1,
      Processado: 2,
      'Não Processado': 5,
    };

    if (
      reason[data.requisitionReason] === 15 &&
      !getSegundaViaCartao?.response?.nameAttachment &&
      !files
    ) {
      return toast.error(
        <WarningToast>
          Para o motivo selecionado é necessário incluir um anexo.
        </WarningToast>
      );
    }

    if (actionLabel === 'Editar Solicitação') {
      const newUpdateSolicitationParams = produce(
        updateSolicitation,
        (draft) => {
          draft.requisition_id = idSolicitacao;
          draft.reason_code = reason[data.requisitionReason];
          draft.description = data.description ? data.description : null;
          draft.status_code = statusCode[data.status];
          draft.is_need_attachment =
            !getSegundaViaCartao?.response?.nameAttachment &&
            reason[data.requisitionReason] === 15;

          draft.beneficiary_id = getSegundaViaCartao?.response?.beneficiaryId;

          if (reason[data.requisitionReason] === 15 && files) {
            draft.attachment = files.base64Data;
            draft.name_attachment = files.fileName;
          } else {
            draft.attachment = null;
            draft.name_attachment = null;
          }
        }
      );
      setUpdateSolicitation(newUpdateSolicitationParams);
      if (deleteAttachment || newUpdateSolicitationParams.reasonCode !== 15) {
        dispatch(RequisicaoActions.deleteSegundaViaAnexoRequest(idSolicitacao));
      }
      return dispatch(
        RequisicaoActions.putSegundaViaUpdateRequest(
          newUpdateSolicitationParams
        )
      );
    }
    const solicitationParams = produce(newSolicitation, (draft) => {
      draft.beneficiary_id = state.data.beneficiaryId;
      draft.document_number = state.data.documentNumber;
      draft.wallet_number = state.data.beneficiaryUniqueCode.substring(4);
      draft.beneficiary_requisition_filter =
        state.data.beneficiary_requisition_filter;
      draft.request_reason_id = reason[data.requisitionReason];
      draft.description = data.description ? data.description : null;
      if (reason[data.requisitionReason] === 15 && files) {
        draft.attachment = files.base64Data;
        draft.name_attachment = files.fileName;
        draft.is_need_attachment = true;
      } else {
        draft.attachment = null;
        draft.name_attachment = null;
        draft.is_need_attachment = false;
      }
    });
    setNewSolicitation(solicitationParams);

    dispatch(
      RequisicaoActions.postSolicitarSegundaViaRequest(solicitationParams)
    );
  };

  const handleFiles = (file) => {
    setFiles(file);
  };

  const handleDeleteSolicitation = () => {
    const params = {
      requisitionId: idSolicitacao,
      userId: usuario.idUsuarioLogado,
    };

    dispatch(RequisicaoActions.deleteSegundaViaRequest(params));
  };

  const handleDeleteAttachment = () => {
    const newData = { ...getSegundaViaCartao.response };
    delete newData.nameAttachment;
    setDeleteAttachment(true);
    dispatch(RequisicaoActions.postSegundaViaCartaoSuccess(newData, true));
    handleModalSuccess('anexo');
  };

  const handleDownloadAttachment = () => {
    dispatch(RequisicaoActions.getSegundaViaAnexoRequest(idSolicitacao));
  };

  const handleModalSuccess = (type) => {
    const typeModal = {
      update: 'Solicitação Atualizada!',
      anexo: 'Anexo Removido!',
      nova: 'Uma Nova Solicitação Foi Registrada.',
    };

    if (type === 'nova') {
      return setOpenModalSuccess({
        success: !openModalSuccess.success,
        message: typeModal[type],
        onClick: () =>
          history.push({
            pathname: `/novo/segunda-via/`,
          }),
      });
    }
    if (type === 'anexo') {
      return setOpenModalSuccess({
        success: !openModalSuccess.success,
        message: typeModal[type],
        onClick: () => setOpenModalSuccess(false),
      });
    }

    return setOpenModalSuccess({
      success: !openModalSuccess.success,
      message: typeModal[type],
      onClick: () => history.go(0),
    });
  };

  if (getSegundaViaCartao.loading) {
    return (
      <Container>
        <FadeIn>
          <WrapperFlex justifyStart alignStart column>
            <WrapperFlex fullWidth justifySpaceBetween alignStart>
              <Title
                text={`2ªvia - ${actionLabel}`}
                color={theme.titleGray}
                fontSize={38}
              />
            </WrapperFlex>
            <Breadcrumbs
              crumbs={[
                { path: 'novo' },
                {
                  path: '2ª via de cartão',
                  onNavigate: () =>
                    history.push({
                      pathname: `/novo/segunda-via/`,
                      state: state?.filter || null,
                    }),
                },
                {
                  path: actionLabel,
                },
              ]}
            />
          </WrapperFlex>

          <WrapperFlex column fullWidth alignCenter>
            <Text text="Carregando informações da solicitação..." />
            <LoadingSpinner />
          </WrapperFlex>
        </FadeIn>
      </Container>
    );
  }

  return (
    <Container>
      <FadeIn>
        <WrapperFlex justifyStart alignStart column>
          <WrapperFlex fullWidth justifySpaceBetween alignStart>
            <Title
              text={`2ªvia - ${actionLabel}`}
              color={theme.titleGray}
              fontSize={38}
            />
          </WrapperFlex>
          <Breadcrumbs
            crumbs={[
              { path: 'novo' },
              {
                path: '2ª via de cartão',
                onNavigate: () =>
                  history.push({
                    pathname: `/novo/segunda-via/`,
                    state: state?.filter || null,
                  }),
              },
              {
                path: actionLabel,
              },
            ]}
          />
        </WrapperFlex>
        <DetalheSolicitacao
          data={
            actionLabel !== 'Nova Solicitação'
              ? getSegundaViaCartao?.response
              : state?.data || {}
          }
        />
        <Form onSubmit={handleSubmit}>
          <FormSolicitacao
            data={
              actionLabel !== 'Nova Solicitação'
                ? getSegundaViaCartao?.response
                : state?.data || {}
            }
            onClickDeleteSolicitation={() => setOpenModal(true)}
            actionLabel={actionLabel}
            handleFiles={handleFiles}
            files={files}
            onDeleteAttachment={handleDeleteAttachment}
            onDownloadAttachment={handleDownloadAttachment}
          />
        </Form>

        {actionLabel !== 'Nova Solicitação' && (
          <CardPersonalInformation>
            <WrapperFlex fullWidth column>
              <Title
                color={theme.greenDefault}
                fontSize={20}
                marginBottom={5}
                text="Mensagens"
              />

              <Table
                head={
                  <TableListaHeader
                    listNameHeaders={[
                      { name: 'Nome' },
                      { name: 'Data' },
                      { name: 'Mensagem' },
                    ]}
                  />
                }
              >
                {getSegundaViaCartao?.response?.requisitionChats?.map(
                  (message) => (
                    <TableContent data={message} key={message.createdAt} />
                  )
                )}
              </Table>
            </WrapperFlex>
          </CardPersonalInformation>
        )}
        <ModalSolicitacoes
          confirm={handleDeleteSolicitation}
          isOpen={openModal}
          handleModal={setOpenModal}
        />
        <ModalSuccess
          handleModalSuccess={handleModalSuccess}
          openModalSuccess={openModalSuccess}
        />
      </FadeIn>
    </Container>
  );
}

export default SolicitacaoSegundaVia;

const TableListaHeader = ({ listNameHeaders }) => {
  return (
    <TableRow>
      {listNameHeaders.map((header) => (
        <TableHeader
          key={header.name}
          minWidth={header.minWidth}
          maxWidth={header.maxWidth}
        >
          {header.name}
        </TableHeader>
      ))}
    </TableRow>
  );
};
const TableContent = ({ data }) => {
  const formatDate = (date) => {
    const dataFormated = date
      ? format(new Date(date), 'dd/MM/yyyy HH:mm', {
          timeZone: 'America/Sao_Paulo',
        })
      : '';
    return dataFormated;
  };
  return (
    <TableRow>
      <TableCell width={100}>{data.loginName}</TableCell>
      <TableCell width={100}>{formatDate(data.createdAt)}</TableCell>
      <TableCell width={300}>{data.dialog}</TableCell>
    </TableRow>
  );
};
